var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-8 text-center"},[_c('div',{staticClass:"padding-top-2x mt-2 hidden-lg-up"}),_c('AddressManager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }